namespace Matrix {

    export class SiteEntityGrid<TItem, TOptions> extends Serenity.EntityGrid<TItem, TOptions> {
        private autoColumnWidth: Serenity.AutoColumnWidthMixin;
        private autoSizingColumns: number = 0;

        constructor(container: JQuery, options?: TOptions) {
            super(container, options);

            this.createHeaderFilters();

            var insertPermission = this.getInsertPermission();
            this.toolbar && this.toolbar.findButton(".add-button").toggle(!(insertPermission != null &&
                !Q.Authorization.hasPermission(insertPermission)));


            var autoColumnWidthOptions = this.getAutoColumnWidthOptions();
            if (autoColumnWidthOptions != null) {
                this.autoColumnWidth = new Serenity.AutoColumnWidthMixin(autoColumnWidthOptions);
                this.autoSizeColumns();
                this.slickGrid.onColumnsResized.subscribe(() => {
                    if (!this.autoSizingColumns && !this.autoColumnWidth.autoSizingAll)
                        this._disableAutoSizeColumns = true;
                });
            }
        }

        protected _disableAutoSizeColumns: boolean;

        protected autoSizeColumns() {
            if (this._disableAutoSizeColumns)
                return;

            this.autoSizingColumns++;
            try {
                this.autoColumnWidth && this.autoColumnWidth.autoSizeAllColumns();
            }
            finally {
                this.autoSizingColumns--;
            }
        }

        protected markupReady() {
            super.markupReady();
            this.autoSizeColumns();
        }

        protected persistSettings(flags?: Serenity.GridPersistanceFlags) {
            if (this.autoSizingColumns)
                return;

            super.persistSettings(flags);
        }

        protected getCurrentSettings(flags?: Serenity.GridPersistanceFlags): Serenity.PersistedGridSettings {
            flags = flags || this.gridPersistanceFlags();
            flags.columnWidths = Q.coalesce(flags.columnWidths, !!this._disableAutoSizeColumns);
            return super.getCurrentSettings(flags);
        }

        protected restoreSettings(settings?: Serenity.PersistedGridSettings, flags?: Serenity.GridPersistanceFlags) {
            if (settings == null)
                settings = this.getPersistedSettings();

            flags = flags || this.gridPersistanceFlags();

            if (settings != null &&
                settings.columns &&
                (flags.columnWidths || Q.any(settings.columns, x => x.width != null)))
                this._disableAutoSizeColumns = true;

            super.restoreSettings(settings, flags);
        }

        protected createHeaderFilters() {
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
        }

        protected getAutoColumnWidthOptions(): Serenity.AutoColumnWidthMixinOptions {
            return {
                grid: this,
                useExplicitWidths: () => this._disableAutoSizeColumns == null,
                maxRows: 100,
                maxWidth: 400,
                minWidth: 30,
                beforeUserAutoSizeAll: () => this._disableAutoSizeColumns = false,
                afterUserAutoSizeAll: () => this._disableAutoSizeColumns = false
            };
        }

        protected useExcelExport() {
            return true;
        }

        protected excelExportAction() {
            return "ListExcel";
        }

        protected getInsertPermission() {
            return Q.tryGetText("Db." + this.getLocalTextPrefix() + ".Permissions.Insert");
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            if (this.useExcelExport()) {
                buttons.push(Matrix.Common.ExcelExportHelper.createToolButton({
                    grid: this,
                    onViewSubmit: () => this.onViewSubmit(),
                    service: this.getService() + '/' + this.excelExportAction(),
                    separator: false
                }));
            }
            return buttons;
        }

        protected getSlickOptions(): Slick.GridOptions {
            var opt: Slick.GridOptions = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            return opt;
        }

        protected isMainPageGrid() {
            return this.element.is("#GridDiv") || this.element.parent().is("section.content");
        }

        protected useQueryCriteria() {
            return (this.options as any).useQueryCriteria ?? this.isMainPageGrid();
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            handleQueryCriteria(this.toolbar.element, this.view.params, this.useQueryCriteria());
            return true;
        }
    }

    export function handleQueryCriteria(container: JQuery, request: Serenity.ListRequest,
        useQueryCriteria: boolean) {
        var qci = container.children('.query-criteria-info');

        var qc: string;
        if (!useQueryCriteria ||
            (qc = (Q.parseQueryString()["criteria"])) == null || !qc.length) {
            qci.remove();
            return;
        }

        var qciHtml = `<i class="fa fa-filter"></i> <em>${Q.htmlEncode(qc)}</em> 
 <a href="javascript:;" title="remove filter"><i class="fa fa-times text-red" style="margin-left: 4px"></i></a>`;
        if (qci.length) {
            qci.html(qciHtml)
        }
        else {
            qci = $('<div class="query-criteria-info">' + qciHtml + '</div>').appendTo(container);
        }

        qci.children('a').click(() => {
            var url = window.location.href;
            var idx = url.indexOf('#');
            var hash = idx >= 0 ? url.substr(idx) : '';
            url = idx >= 0 ? url.substr(0, idx) : url;
            idx = url.indexOf('?');
            var q = idx >= 0 ? url.substr(idx + 1) : '';
            q = q.split('&').filter(x => !Q.startsWith(x.toLowerCase(), "criteria=")).join('&');
            window.location.href = (idx >= 0 ? url.substr(0, idx) : url) +
                (q.length > 0 ? '?' : '') + q + hash;
        });

        const criteria = Serenity.Criteria.parse(qc);
        if (criteria && criteria.length) {
            request.Criteria = Serenity.Criteria.and(request.Criteria, criteria);
        }
    }
}